export const inputsForModalWindowProtocolHistory = {
  fio: {
    key: "fio",
    value: "Фамилия Имя Отчество",
    type: "text",
    readOnly: true,
    disabled: true,
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "text",
    readOnly: true,
    disabled: true,
  },
};
